import React, { useEffect, useState } from "react";
import LoginContent from "@/parent-components/LoginProcess/LoginContent";
import {
  applicationLabelFetchData,
  fetchParentData,
} from "../../parentService/parentApi";
import {
  CMS_LOGIN,
  CMS_VERIFY_OTP,
  PARENT_CONATCTUS,
  PARENT_HEADER_AND_FOOTER_LOGGED_OFF,
} from "../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  clearData,
  clearForgeRockAuthInfo,
  selectParentContactusCmsData,
  selectParentHeaderAndFooterLoggedOutData,
  selectParentLoginCmsData,
  selectParentOtpCmsData,
  setParentContactusCmsData,
  setParentHeaderAndFooterDataLoggedOut,
  setParentLoginCmsData,
  setParentOtpCmsData,
} from "@/redux/dataSlice";
import router from "next/router";
import OverlayLoader from "@/parent-components/OverlayLoader";
import useParentHeaderFooter from "@/hooks/useParentHeaderFooter";

const LoginPage = () => {
  const dispatch = useDispatch();
  const [loginData, setLoginData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // const getLoginData = useSelector(selectParentLoginCmsData);
  // const getHeaderData = useSelector(selectParentHeaderAndFooterLoggedOutData);
  // const getContactusData = useSelector(selectParentContactusCmsData);
  // const getLoginOtpData = useSelector(selectParentOtpCmsData);

  dispatch(clearForgeRockAuthInfo());
  dispatch(clearData());

  useEffect(() => {
    try{
    const fetchData = async () => {
      let attempts = 0;
      const maxAttempts = 2;

      while (attempts < maxAttempts) {
        try {
          const data = await fetchParentData(CMS_LOGIN);
          if (data?.data) {
            dispatch(setParentLoginCmsData(data));
            setLoginData(data);
            setIsLoading(false);
            break;
          }
        } catch (error) {
          setIsLoading(false);
          console.error("error --->", error);
        }
        attempts++;
      }

      if (attempts === 2) {
        router.push({
          pathname: "/",
        });
      }

     
        
        const hnfDataLo = await useParentHeaderFooter(
          PARENT_HEADER_AND_FOOTER_LOGGED_OFF
        );
        if (hnfDataLo?.data) {
          dispatch(setParentHeaderAndFooterDataLoggedOut(hnfDataLo));
        }
      
        const contactusData = await applicationLabelFetchData(PARENT_CONATCTUS);
        if (contactusData?.data) {
          dispatch(setParentContactusCmsData(contactusData));
        }
      
        const loginOtpData = await applicationLabelFetchData(CMS_VERIFY_OTP);
        if (loginOtpData?.data) {
          dispatch(setParentOtpCmsData(loginOtpData));
        }
      

    };

    // if (getLoginData) {
    //   setIsLoading(false);
    //   setLoginData(getLoginData);
    // } else {
    //   fetchData();
    // }
    fetchData();
  }catch(e){
    console.log('error: ', e);
  }
  }, []);

  if (isLoading) {
    return <OverlayLoader />;
  }

  return <LoginContent data={loginData} />;
};

export default LoginPage;
